var map = {
	"./usp-barcode.svg": "./src/js/components/WhatIsLifesum/images/usp-barcode.svg",
	"./usp-diets.svg": "./src/js/components/WhatIsLifesum/images/usp-diets.svg",
	"./usp-mealplans.svg": "./src/js/components/WhatIsLifesum/images/usp-mealplans.svg",
	"./usp-personalize-2.svg": "./src/js/components/WhatIsLifesum/images/usp-personalize-2.svg",
	"./usp-personalize.svg": "./src/js/components/WhatIsLifesum/images/usp-personalize.svg",
	"./usp-recipes.svg": "./src/js/components/WhatIsLifesum/images/usp-recipes.svg",
	"./usp-trackers.svg": "./src/js/components/WhatIsLifesum/images/usp-trackers.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/js/components/WhatIsLifesum/images sync recursive ^\\.\\/.*$";